"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRelative = void 0;

var isRelative = function isRelative(url) {
  return !url.match(/^(\/\/|https?:\/\/|mailto:)/);
};

exports.isRelative = isRelative;